import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Form, Input } from "@/Components/Common/Tailwind";
import { useUserStore } from "../../../store/store";
import styled from "styled-components";
import {
  getGiftSendErrorMessage,
  isGiftSendSuccess,
  normalizeGiftPhoneNumber,
} from "../../../common/social/kakao/giftShare.mjs";

const PhoneLi = styled.li`
  list-style: none;
  padding: 5px 0px;
  background-color: #f5f5f5;
  border-radius: 5px;
  display: inline-block;
  margin: 5px;
  padding: 5px 8px;
  font-size: 12px;
  cursor: pointer;
`;

const DeleteBtn = styled.button`
  background-color: transparent;
  color: #ff5a5f;
  font-weight: bold;
  border: none;
  /* border-radius: 50%; */
  width: 15px;
  height: 15px;
  font-size: 10px;
  margin-left: 10px;
  cursor: pointer;
`;

function formatPhoneNumber(value) {
  const normalized = normalizeGiftPhoneNumber(value);
  if (!normalized) return value;
  return normalized.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
}

function telValidator(args) {
  return Boolean(normalizeGiftPhoneNumber(args));
}
const confirm = (message = null, onConfirm, onCancel) => {
  if (!onConfirm || typeof onConfirm !== "function") return;
  if (onCancel && typeof onCancel !== "function") return;
  const confirmAction = () => {
    if (window.confirm(message)) onConfirm();
    else onCancel();
  };
  return confirmAction;
};

export default function GiftPhoneNumList({
  info,
  setInfo,
  visible,
  setVisible,
  needRefresh,
  sendItem,
  manyPeople = false,
  sendCount = 1,
}) {
  const [phoneNum, setPhoneNum] = useState("");
  const [user] = useUserStore((state) => [state.user]);
  const [hashTags, setHashTags] = useState([]);

  const [showDescription, setShowDescription] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const digits = phoneNum.replace(/\D/g, "");
    if (digits.length === 11 && phoneNum !== formatPhoneNumber(digits)) {
      setPhoneNum(formatPhoneNumber(digits));
    }
  }, [phoneNum]);

  const handleInputChange = (event) => {
    setPhoneNum(event.target.value);
  };

  const handleEnterKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      enrollPhoneNumber();
    }
  };

  const enrollPhoneNumber = () => {
    const normalizedPhone = normalizeGiftPhoneNumber(phoneNum);
    if (normalizedPhone && hashTags.length < info.stock) {
      setHashTags((prevTags) => {
        const uniqueNumbers = new Set([...prevTags, formatPhoneNumber(normalizedPhone)]);
        return [...uniqueNumbers];
      });
      setPhoneNum("");
    } else if (hashTags.length >= info.stock) {
      toast.error(`현재 전송 가능한 쿠폰 개수는 ${info.stock}개입니다.`);
    } else {
      toast.error("올바른 전화번호 형식이 아닙니다.");
    }
  };

  const handleDeleteTag = (index) => {
    setHashTags((prevTags) => prevTags.filter((tag, i) => i !== index));
  };

  const isValidPhoneNumber = (number) => {
    return Boolean(normalizeGiftPhoneNumber(number));
  };

  const handleSendFailure = (error, fallback = "전송 실패") => {
    toast.error(getGiftSendErrorMessage(error, fallback));
  };

  const handleUnexpectedResponse = (data) => {
    handleSendFailure({ response: { data } }, "전송 실패");
  };

  return (
    <div>
      <div className="mx-3 my-3">
        <div
          className="flex justify-content-start cursor-pointer btn-ghost"
          onClick={() => setShowDescription((prev) => !prev)}
        >
          {showDescription ? "사용방법 닫기 >" : "사용방법 보기 >"}
        </div>
        {showDescription ? (
          <>
            <div className="my-3 flex justify-center">
              <h4
                className="mb-sm-0"
                style={{ fontFamily: "Gmarket-M", fontSize: "16px" }}
              >
                전화번호로 선물하기
              </h4>
            </div>
            <div style={{ marginTop: "10px" }}></div>
            <div>
              <p
                style={{
                  fontSize: "14px",
                  lineHeight: "24px",
                  textAlign: "center",
                }}
              >
                입력하신 전화번호가 기존의 가입된 회원일 경우 쿠폰이 선물됩니다.
                <br />
                가입되지 않은 전화번호일 경우, 초대장이 전송됩니다.
              </p>
            </div>
            <div style={{ marginTop: "20px" }}></div>
          </>
        ) : null}
        <Form>
          {manyPeople ? (
            <>
              <ul
                style={{
                  paddingLeft: 0,
                  border: "1px solid #feedea",
                  height: "80px",
                  overflowY: "scroll",
                }}
              >
                {hashTags.map((tag, index) => (
                  <PhoneLi key={index} onClick={() => handleDeleteTag(index)}>
                    {tag} <DeleteBtn>X</DeleteBtn>
                  </PhoneLi>
                ))}
              </ul>
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  border: "1px solid #E9EBEC",
                  borderRadius: "5px",
                  justifyContent: "space-between",
                }}
              >
                <Input
                  value={phoneNum}
                  onChange={handleInputChange}
                  onKeyDown={handleEnterKeyPress}
                  type="text"
                  className="form-control"
                  id="gift-reserv-phone"
                  placeholder="휴대폰번호"
                  style={{ width: "80%", borderWidth: "0px" }}
                ></Input>

                <Button
                  style={{
                    fontFamily: "Gmarket-S",
                    borderColor: "#ff5a5f",
                    color: "#fff",
                    backgroundColor: "#ff5a5f",
                    margin: "8px",
                    padding: "6px",
                  }}
                  onClick={enrollPhoneNumber}
                >
                  등록
                </Button>
              </div>
            </>
          ) : (
            <Input
              value={phoneNum}
              onChange={(e) => {
                setPhoneNum(e.currentTarget.value);
              }}
              type="text"
              className="form-control"
              id="gift-reserv-phone"
              placeholder="휴대폰번호"
            />
          )}

          {/* <div style={{ marginTop: "5px", color: "GrayText", marginLeft: "5px" }}>받으실 분의 휴대폰 번호를 입력해 주세요.</div> */}
          {manyPeople ? (
            <div
              style={{ marginTop: "5px", color: "GrayText", marginLeft: "5px" }}
            >
              *전화번호 작성후 엔터를 누르면 번호 추가가 됩니다.
            </div>
          ) : null}
        </Form>
      </div>
      <div className="flex justify-center mx-1 mb-4">
        <Button
          style={{
            fontFamily: "Gmarket-M",
            backgroundColor: "#fff",
            borderColor: "#ff5a5f",
            color: "#ff5a5f",
          }}
          color="light ms-2 my-2"
          disabled={isSubmitting}
          onClick={() => {
            setPhoneNum("");
            setVisible(false);
            setInfo({});
          }}
        >
          닫기
        </Button>

        {manyPeople ? (
          <Button
            style={{}}
            disabled={isSubmitting}
            onClick={() => {
              if (isSubmitting) return;
              if (hashTags.length === 0) {
                if (!isValidPhoneNumber(phoneNum)) {
                  toast.error("올바른 형식이 아닙니다.");
                  return;
                } else if (phoneNum == "") {
                  toast.warning("보내실 번호를 입력해주세요.");
                  return;
                }
              }

              if (hashTags.length * sendCount > info.stock) {
                toast.warning("총 발송 가능한 개수는 " + info.stock + "개 입니다.");
                return;
              }

              confirm(
                `쿠폰을 선물하시겠습니까?`,
                () => {
                  if (info) {
                    let phone_num = hashTags
                      .map((phoneNum) => normalizeGiftPhoneNumber(phoneNum))
                      .filter(Boolean);
                    const pendingPhone = normalizeGiftPhoneNumber(phoneNum);
                    if (pendingPhone) {
                      phone_num = phone_num.concat(pendingPhone);
                    }

                    setIsSubmitting(true);
                    sendItem(info.id, phone_num)
                      .then((data) => {
                        if (isGiftSendSuccess(data)) {
                          toast.success("전송 성공");
                          setPhoneNum("");
                          setInfo({});
                          setVisible(false);
                          needRefresh();
                        } else {
                          handleUnexpectedResponse(data);
                        }
                      })
                      .catch((e) => {
                        console.log(e);
                        handleSendFailure(e);
                      })
                      .finally(() => {
                        setIsSubmitting(false);
                      });
                  }
                },
                () => { }
              )();
            }}
            className="ms-2 my-2"
          >
            선물하기
          </Button>
        ) : (
          <Button
            style={{
              fontFamily: "Gmarket-M",
              backgroundColor: "#ff5a5f",
              borderColor: "#ff5a5f",
              color: "#fff",
            }}
            disabled={isSubmitting}
            onClick={() => {
              if (isSubmitting) return;
              if (!telValidator(phoneNum)) {
                toast.error("잘못된 번호 형식입니다!");
                return;
              }

              confirm(
                `${phoneNum} 님께 쿠폰을 선물하시겠습니까?`,
                () => {
                  if (info) {
                    const phone_num = normalizeGiftPhoneNumber(phoneNum);

                    if (normalizeGiftPhoneNumber(user.phone) === phone_num) {
                      toast.error("본인에게는 선물할 수 없습니다.");
                      return;
                    }

                    setIsSubmitting(true);
                    sendItem(info.id, phone_num)
                      .then((data) => {
                        if (isGiftSendSuccess(data)) {
                          toast.success("전송 성공");
                          setPhoneNum("");
                          setInfo({});
                          setVisible(false);
                          needRefresh();
                        } else {
                          handleUnexpectedResponse(data);
                        }
                      })
                      .catch((e) => {
                        console.log(e);
                        handleSendFailure(e);
                      })
                      .finally(() => {
                        setIsSubmitting(false);
                      });
                  }
                },
                () => { }
              )();
            }}
            className="ms-2 my-2"
          >
            선물하기
          </Button>
        )}
      </div>
    </div>
  );
}
